import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Paper, Typography } from "@mui/material";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import AccesparkForm from "./components/AccesparkForm";
import AccesparkHistory from "./components/AccesparkHistory";
export default function CiclosAccespark({ system }) {
  const openingType = system === "ezytec" ? 4 : 3;
  const closingType = system === "ezytec" ? 5 : 2;
  const name = system === "ezytec" ? "Ezytec" : "Accespark";
  const [type, setType] = useState(openingType),
    [refreshFlag, setRefreshFlag] = useState(false);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ py: 3 }}>
        <Box sx={{ bgcolor: "#183b50", p: 3, borderRadius: "12px 12px 0 0" }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "1.15rem" }}>
            Ciclos {name}
          </Typography>
          <Typography sx={{ color: "#d7e5ee", fontSize: ".8rem" }}>
            Operaciones por terminal · Fecha y hora de Colombia (UTC−5)
          </Typography>
        </Box>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, borderRadius: "0 0 12px 12px" }}>
          <AccesparkForm system={system} onComplete={() => setRefreshFlag((value) => !value)} />
        </Paper>
        <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 3 }}>
          <Typography sx={{ color: "#526579", fontSize: ".8rem", mb: 1.5 }}>
            Seleccione el historial que desea consultar
          </Typography>
          <Box
            role="tablist"
            aria-label={`Historiales ${name}`}
            sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 3 }}
          >
            {[
              [openingType, "Aperturas", "#14634e", "#e7f4ed", LoginOutlinedIcon],
              [closingType, "Cierres", "#4657a1", "#eef0fb", LogoutOutlinedIcon],
            ].map(([value, label, color, background, Icon]) => (
              <Button
                key={value}
                role="tab"
                aria-selected={type === value}
                aria-controls={`${system}-history-${value}`}
                id={`${system}-tab-${value}`}
                onClick={() => setType(value)}
                startIcon={<Icon />}
                sx={{
                  minHeight: 60,
                  borderRadius: 2,
                  fontSize: "1rem",
                  fontWeight: 700,
                  textTransform: "none",
                  border: `2px solid ${color}`,
                  bgcolor: type === value ? color : background,
                  color: type === value ? "#fff" : color,
                  "&&:focus, &&:focus:not(:hover), &&:active": {
                    color: type === value ? "#fff" : color,
                  },
                  "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                  boxShadow: type === value ? `0 3px 10px ${color}33` : "none",
                  "&&:hover": { bgcolor: color, color: "#fff" },
                  "&:focus-visible": { outline: `3px solid ${color}`, outlineOffset: 3 },
                }}
              >
                {label}
              </Button>
            ))}
          </Box>
          <Box
            role="tabpanel"
            id={`${system}-history-${type}`}
            aria-labelledby={`${system}-tab-${type}`}
            sx={{ borderTop: `4px solid ${type === openingType ? "#14634e" : "#4657a1"}`, pt: 2.5 }}
          >
            <AccesparkHistory
              key={`${system}-${type}`}
              type={type}
              system={system}
              refreshFlag={refreshFlag}
            />
          </Box>
        </Paper>
      </Box>
    </DashboardLayout>
  );
}
CiclosAccespark.propTypes = { system: PropTypes.oneOf(["accespark", "ezytec"]) };
CiclosAccespark.defaultProps = { system: "accespark" };
